import { isWishlistCollectionSlug, isPDPPage } from '~/util/global';

export default {
  async fetch({
    route,
    store,
    $toastr,
  }) {
    const isWishlistCollection = isWishlistCollectionSlug(route?.params.pathMatch);
    const isPDP = isPDPPage(route?.params.pathMatch);

    if (isWishlistCollection || isPDP) {
      await store.dispatch('wishlists/getWishlists');
      const requestErrorMessage = store.getters['wishlists/errorMessage'];

      if (requestErrorMessage && $toastr) {
        $toastr.e(requestErrorMessage);
      }
    }
  },
};
